<template>
  <TemplateDefault :has-timeline="false">
    <template #main>
      <UsersSignInMain />
    </template>

    <template #footer>
      <FooterGlobal
        :has-download-app="false" />
    </template>
  </TemplateDefault>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import UsersSignInMain from './Main.vue'
import FooterGlobal from '@/components/_core/FooterGlobal.vue'

export default defineComponent({
  name: 'UsersSignInApp',

  components: {
    UsersSignInMain,
    FooterGlobal,
  },
})
</script>
